<template>
    <b-container fluid class="px-0">
        <b-row class="mb-3">
            <b-col cols="12" md="3">
                <b-input-group>
                    <template v-slot:prepend>
                        <b-btn style="cursor:default;" class="font-weight-bold">Server Name</b-btn>
                    </template>
                    <b-form-select :disabled="disableServer" v-model="filter.ServerName" value-field="fullName" text-field="fullName" :options="servers" @change="changeServerName"></b-form-select>
                </b-input-group>
            </b-col>
            <b-col cols="2" class="d-none d-md-block">
            </b-col>
            <b-col cols="2" class="d-none d-md-block">
            </b-col>
            <b-col cols="12" sm="4" class="mt-3 mt-md-0">
                <b-button-group>
                    <b-button @click="changeDateMode('yesterday')" :class="type === 'yesterday' ? 'active-button-group' : 'bg-white'">Yesterday</b-button>
                    <b-button @click="changeDateMode('today')" :class="type === 'today' ? 'active-button-group' : 'bg-white'">Today</b-button>
                </b-button-group>
            </b-col>
        </b-row>
<!--        <b-row class="mb-5">-->
<!--            <b-col cols="12">-->
<!--                <div class="text-center h5 font-weight-bold">-->
<!--                    Server Shift Report-->
<!--                </div>-->
<!--                <div class="text-center h5 font-weight-bold">-->
<!--                    For {{convertDate(filter.FromDate, 'noTime')}}-->
<!--                </div>-->
<!--                <div class="text-center" v-if="result.length">-->
<!--                    Created on {{convertDate(result[0].CreateDate)}}-->
<!--                </div>-->
<!--            </b-col>-->
<!--        </b-row>-->
        <b-row v-if="result.length">
            <b-col cols="12" md="9">
                <b-row class="mb-3">
                    <b-col>
                        <div class="text-danger font-weight-bold">
                            NOTE: Make sure no open tabs (unpaid or unserved) exist in Today Order to get accurate data on this page.
                        </div>
                    </b-col>
                </b-row>
                <b-row v-for="(item, index) in result" class="border-bottom-blueGray pb-4">
                    <b-col cols="12" v-if="index === 0">
                        <section class="mb-3">
                            <div class="text-center h5 font-weight-bold">
                                Server Shift Report
                            </div>
                            <div class="text-center h5 font-weight-bold">
                                For {{convertDate(filter.FromDate, 'noTime')}}
                            </div>
                            <div class="text-center" v-if="result.length">
                                Created on {{convertDate(result[0].OrderDate)}}
                            </div>
                        </section>
                    </b-col>
                    <b-col cols="12" sm="6" md="4">
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Server: {{item.ServerName}}
                            </div>
                            <div class="font-weight-bold">
                                Total Gross Sales (Subtotals):
                                <currency-display :value="item.Gross_Sale"/>
                            </div>
                            <div>
                                Food & Non-Alcoholic Drinks:
                                <currency-display :value="item.Gross_Sale_NAL_Drink + item.Gross_Sale_Food"/>
                            </div>
                            <div>
                                Alcoholic Drinks:
                                <currency-display :value="item.Gross_Sale_AL_Drink"/>
                            </div>
                        </section>
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Total Tax:
                                <currency-display :value="item.Taxes"/>
                            </div>
                            <div>
                                Food & Non-Alcoholic Drinks:
                                <currency-display :value="item.Tax_Food_NAL_Drink"/>
                            </div>
                            <div>
                                Alcoholic Drinks:
                                <currency-display :value="item.Tax_Alc_Drink"/>
                            </div>
                        </section>
                        <section>
                            <div class="font-weight-bold">
                                Tip Out to House:
                                <currency-display :value="item.Tip_Outhouse"/>
                            </div>
                            <div class="font-weight-bold">
                                Cash Owed to House:
                                <currency-display v-if="item.Server_Balance <= 0" :value="Math.abs(item.Server_Balance)"/>
                                <span v-else>$0.00</span>
                            </div>
                            <div class="font-weight-bold">
                                Money Owed to Server:
                                <currency-display v-if="item.Server_Balance > 0 " :value="Math.abs(item.Server_Balance)"/>
                                <span v-else>$0.00</span>
                            </div>
                        </section>
                    </b-col>
                    <b-col cols="12" sm="6" md="4">
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Total Credit Applied:
                                <currency-display :value="item.Credits"/>

                            </div>
                            <div class="font-weight-bold">
                                Total Voids:
                                <currency-display :value="item.Voids"/>
                            </div>
                            <div class="font-weight-bold">
                                Total Refunds:
                                <currency-display :value="item.Refunds"/>
                            </div>
                        </section>
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Total Tip:
                                <currency-display :value="item.Tips"/>
                            </div>
                            <div>
                                Card:
                                <currency-display :value="item.Tip_Card"/>
                            </div>
                            <div>
                                Cash:
                                <currency-display :value="item.Tip_Cash"/>
                            </div>
                        </section>
                        <section>
                            <div class="">
                                Number of Tabs: {{item.No_Of_Tabs}}
                            </div>
                            <div class="">
                                Average Tab Amount (Gross Sales):
                                <currency-display :value="item.Avg_Tab_Amount"/>
                            </div>
                            <div class="">
                                Average Tip Percentage: {{item.Avg_Tip_Percent !== 0 ? item.Avg_Tip_Percent.toFixed(2) : 0}}
                            </div>
                            <div class="">
                                Served Tab Nos: {{item.Serverd_Tabs}}
                            </div>
                        </section>
                    </b-col>
                    <b-col cols="12" sm="6" md="4">
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Total Net Sales (Subtotals after credit):
                                <currency-display :value="item.Net_Sale"/>
                            </div>
                            <div class="">
                                Food & Non-Alcoholic Drinks:
                                <currency-display :value="item.Net_Sale_NAL_Drink + item.Net_Sale_Food"/>
                            </div>
                            <div class="">
                                Alcoholic Drinks:
                                <currency-display :value="item.Net_Sale_AL_Drink"/>
                            </div>
                        </section>
                        <section class="mb-5">
                            <div class="font-weight-bold">
                                Total Payments Received:
                                <currency-display :value="item.Paymeny_Received"/>
                            </div>
                            <div>
                                Card:
                                <currency-display :value="item.Paymeny_Received_Card"/>
                            </div>
                            <div>
                                Cash:
                                <currency-display :value="item.Paymeny_Received_Cash"/>
                            </div>
                        </section>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="3">
                <b-row>
                    <b-col cols="12">
                        <div class="mb-4">
                            <b-btn variant="warning" :disabled="!loadPrint" block @click="printModal = true">
                                Print Report Receipt
                            </b-btn>

                            <b-btn variant="warning" block @click="print">
                                Print Page
                            </b-btn>
                        </div>
                        <div>
                            <!--                    <email-report/>-->
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col class="text-danger text-center h4 mt-4 font-weight-bold">
                {{errorTextApi}}
<!--                No tabs exists for this server for the selected period.-->
            </b-col>
        </b-row>
        <b-row v-if="result.length">
            <b-col class="pt-3">
                Note: Sales numbers are rouned to the nearest cent and may vary slightly from report to report.
            </b-col>
        </b-row>
        <vue-easy-print tableShow ref="easyPrint">
            <template slot-scope="func">
                <b-container id="printSection">
                    <b-row v-for="item in result">
                        <b-col cols="12">
                            <div class="font-weight-bold text-center">
                                {{item.RestaurantName}}
                            </div>
                            <div class="font-weight-bold text-center">
                                Server Shift report
                            </div>
                            <div class="font-weight-bold text-center">
                                for date: {{convertDate(item.OrderDate)}}
                            </div>
                            <div class="text-center">
                                Server: {{filter.ServerName}}
                            </div>
                            <div class="mb-4 text-center">
                                Created on date time: {{convertDate(item.OrderDate)}}
                            </div>
                        </b-col>
                        <b-col cols="4">
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Gross Sales (Subtotals):
                                    <currency-display :value="item.Gross_Sale + item.Gross_Sale_Food"/>
                                </div>
                                <div class="">
                                    Food & Non-Alcoholic Drinks:
                                    <currency-display :value="item.Gross_Sale_NAL_Drink + item.Gross_Sale_Food"/>
                                </div>
                                <div class="">
                                    Alcoholic Drinks:
                                    <currency-display :value="item.Gross_Sale_AL_Drink"/>
                                </div>
                            </section>
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Tax:
                                    <currency-display :value="item.Taxes"/>
                                </div>
                                <div class="font-weight-bold">
                                    Food & Non-Alcoholic Drinks:
                                    <currency-display :value="item.Tax_Food_NAL_Drink"/>
                                </div>
                                <div class="font-weight-bold">
                                    Alcoholic Drinks:
                                    <currency-display :value="item.Tax_Alc_Drink"/>
                                </div>
                            </section>
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Tip Out to House:
                                    <currency-display  :value="item.Tip_Outhouse"/>
                                </div>
                                <div class="font-weight-bold">
                                    Cash Owed to House:
                                    <currency-display v-if="item.Server_Balance <= 0" :value="Math.abs(item.Server_Balance)"/>
                                    <span v-else>$0.00</span>
                                </div>
                                <div class="font-weight-bold">
                                    Money Owed to Server:
                                    <currency-display v-if="item.Server_Balance > 0" :value="Math.abs(item.Server_Balance)"/>
                                    <span v-else>$0.00</span>
                                </div>
                            </section>
                        </b-col>
                        <b-col cols="4">
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Credit Applied:
                                    <currency-display :value="item.Credits"/>
                                </div>
                                <div class="font-weight-bold">
                                    Total Voids:
                                    <currency-display :value="item.Voids"/>
                                </div>
                                <div class="font-weight-bold">
                                    Total Refunds:
                                    <currency-display :value="item.Refunds"/>
                                </div>
                            </section>
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Tip:
                                    <currency-display :value="item.Tips"/>
                                </div>
                                <div class="">
                                    Card:
                                    <currency-display :value="item.Tip_Card"/>
                                </div>
                                <div class="">
                                    Cash:
                                    <currency-display :value="item.Tip_Cash"/>
                                </div>
                            </section>
                            <section class="mb-4">
                                <div class="">
                                    Number of Tabs: {{item.No_Of_Tabs}}
                                </div>
                                <div class="">
                                    Average Tab Amount (Gross Sales):
                                    <currency-display :value="item.Avg_Tab_Amount"/>
                                </div>
                                <div class="">
                                    Average Tip Percentage: {{item.Avg_Tip_Percent !== 0 ? item.Avg_Tip_Percent.toFixed(2) : 0}}
                                </div>
                                <div class="">
                                    Served Tab Nos: {{item.Serverd_Tabs}}
                                </div>
                            </section>
                        </b-col>
                        <b-col cols="4">
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Net Sales (Subtotals after credit):
                                    <currency-display :value="item.Net_Sale"/>
                                </div>
                                <div class="font-weight-bold">
                                    Food & Non-Alcoholic Drinks:
                                    <currency-display :value="item.Net_Sale_NAL_Drink + item.Net_Sale_Food"/>
                                </div>
                                <div class="font-weight-bold">
                                    Alcoholic Drinks:
                                    <currency-display :value="item.Net_Sale_AL_Drink"/>
                                </div>
                            </section>
                            <section class="mb-4">
                                <div class="font-weight-bold">
                                    Total Payments Received:
                                    <currency-display :value="item.Paymeny_Received"/>
                                </div>
                                <div class="font-weight-bold">
                                    Card:
                                    <currency-display :value="item.Paymeny_Received_Card"/>
                                </div>
                                <div class="font-weight-bold">
                                    Cash:
                                    <currency-display :value="item.Paymeny_Received_Cash"/>
                                </div>
                            </section>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            Note: Sales numbers are rouned to the nearest cent and may vary slightly from report to report.
                        </b-col>
                    </b-row>
                </b-container>

            </template>
        </vue-easy-print>
        <Cmodal
            v-model="printModal"
            cancel-label="Nerve mind"
            centered size="md"
            title="Please Select Printer"
            :tag="false"
            confirm-label="Apply Credit"
        >
            <template>
                <div v-for="(item, index) in printers">
                    <print-report
                        :class="{'mb-3': index < printers.length - 1}"
                        :value="item"
                        :result="result"
                        :server-ip="serverIp"
                        :load-print="loadPrint"
                        @printStatus="data => printMessage = data"
                    />
                </div>
                <div :class="printMessage.success ? 'text-success' : 'text-danger'">
                    {{printMessage.message}}
                </div>
            </template>
            <template #actions>
                <b-btn variant="danger" block class="text-nowrap" @click="printModal = false">
                    Never mind
                </b-btn>
            </template>
        </Cmodal>
    </b-container>
</template>

<script>
    import EmailReport from "../shared/emailReport";
    import vueEasyPrint from "vue-easy-print";
    import moment from 'moment'
    import currencyDisplay from "../shared/currencyDisplay";
    import JSPM from "jsprintmanager";
    import Cmodal from "../shared/Cmodal";
    import PrintReport from "../shared/printReport";
    export default {
        name: "serverShift",
        components: {PrintReport, EmailReport, vueEasyPrint, currencyDisplay, Cmodal},
        data () {
            return {
                servers: [],
                selected: 'Receipt Printer',
                todayDate: moment().locale('en'),
                filter: {
                    ServerName: '',
                    ToDate: moment().locale('en'),
                    FromDate: moment().locale('en'),
                    IsSum: 1
                },
                type: "today",
                result: [],
                rowPrint: false,
                HasActiveReceiptPrinter: false,
                loadPrint: false,
                printers: [],
                printModal: false,
                serverIp: '',
                printMessage: {},
                loading: false,
                disableServer: false,
                errorTextApi: ''
            }
        },
        watch: {
            '$store.state.selectedRestaurantId': {
                handler: function (newVal) {
                    if (newVal) {
                        let object = {
                            RestaurantID: newVal,
                            // UserID: localStorage.getItem('userID'),
                        }
                        Promise.all([
                            this.getServers(object),
                            this.getPrinters(object),
                            this.GetServerPrinterIP(object)
                        ]).then(() => {

                        })
                    }
                },
                immediate: true
            }
        },
        mounted () {
            moment.locale('en');
        },
        methods: {
            getServers (filter) {
                this.loading = true
                return this.$api.getRestaurant.GetDashboardRestaurantClient(filter).then(res => {
                    this.loading = false
                    if (res.success) {
                        this.ServerName = ''
                        res.RestaurantClients.forEach(item => {
                            item.fullName = item.FirstName + ' ' + item.LastName
                        })
                        const available = res.RestaurantClients.filter(i => i.Role.includes('Restaurant Server'))
                        // value-field="fullName" text-field="fullName"
                        this.servers = [...available]
                        this.disableServer = false
                        if (this.servers.length) {
                            const findCurrentUser = this.servers.find(item => item.ClientID == localStorage.getItem('userID'))
                            if (findCurrentUser) {
                                this.disableServer = true
                                this.filter.ServerName = findCurrentUser.fullName
                            } else {
                                this.filter.ServerName = this.servers[0].fullName
                            }
                            this.GetRestaurantShiftReport(this.filter)
                        } else {
                            this.result = []
                        }
                    }
                }).catch(() => {

                })
            },
            allFill () {
                return this.filter.FromDate && this.filter.ToDate && this.filter.ServerName
            },
            changeFromDate () {
                if (this.allFill()) {
                    this.GetRestaurantShiftReport(this.filter)
                }
            },
            changeToDate () {
                if (this.allFill()) {
                    this.GetRestaurantShiftReport(this.filter)
                }
            },
            changeServerName () {
                if (this.allFill()) {
                    this.GetRestaurantShiftReport(this.filter)
                }
            },
            GetRestaurantShiftReport (filter) {
                moment.locale('en');
                filter.FromDate = moment(this.filter.FromDate).locale('en').format('YYYY-MM-DD')
                filter.ToDate = moment(this.filter.ToDate).locale('en').format('YYYY-MM-DD')
                filter.ServerName = this.filter.ServerName
                filter.RestaurantID = this.$store.state.selectedRestaurantId
                filter.UserID = localStorage.getItem('userID')
                filter.CombinationType = 'SumOfAll'
                return this.$api.getRestaurant.GetRestaurantShiftReport(filter).then(res => {
                    if (res.success) {
                        const findErr = res.OpenItems.find(item => item.errMsg)
                        if (findErr) {
                            this.result = []
                            this.errorTextApi = findErr.errMsg
                        } else {
                            this.result = res.OpenItems
                            this.errorTextApi = res.OpenItems.length === 0 ? 'No tabs exists for this server for the selected period.' : ''
                        }
                    } else {
                        this.$showError(res.message)
                        this.result = []
                        this.errorTextApi = res.message
                    }
                }).catch(() => {

                })
            },
            convertDate (date, noTime) {
                moment.locale('en');
                if (noTime) {
                    return date && moment(date).format('D MMM, YYYY')
                } else {
                    return date && moment(date).format('D MMM YYYY - hh:mm A')
                }
            },
            print () {
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.$refs.easyPrint.print()
                    })
                }, 1000)
            },
            changeDateMode (type) {
                this.type = type
                moment.locale('en');
                if (type === 'today') {
                    this.filter.FromDate = moment().locale('en')
                    this.filter.ToDate = moment().locale('en')
                    this.$nextTick(() => {
                        this.GetRestaurantShiftReport(this.filter)
                    })
                } else {
                    this.filter.FromDate = moment().locale('en').subtract(1, 'days')
                    this.filter.ToDate = moment().locale('en').subtract(1, 'days')
                    this.$nextTick(() => {
                        this.GetRestaurantShiftReport(this.filter)
                    })
                }
            },
            getPrinters (object) {
                this.$api.getRestaurant.GetRestaurantPrinters(object).then(res => {
                    if (res.success) {
                        this.printers = res.results.RestaurantPrinter.filter(i => i.PrintTaskID === 2)
                        this.printers.forEach(item => {
                            this.$set(item, 'deactive', false)
                        })
                    }
                })
            },
            GetServerPrinterIP (object) {
                this.$api.getRestaurant.GetServerPrinterIP(object).then(res => {
                    if (res.success) {
                        this.serverIp = res.results.serverPrinterIp
                        this.onInit(this.serverIp)
                    }
                })
            },
            onInit (serverIp) {
                if (serverIp) {
                    var _this = this;
                    JSPM.JSPrintManager.license_url = _this.$config.printJspmLisence
                    JSPM.JSPrintManager.auto_reconnect = false;
                    JSPM.JSPrintManager.start(true, serverIp, 23443)
                    JSPM.JSPrintManager.WS.onStatusChanged = function () {
                        _this.loadPrint = true
                    };
                }
            },
        }
    }
</script>

<style scoped>
    #printSection{
        display: none;
    }
    @media print {
        #printSection{
            display: block;
        }
    }
    .active-button-group {
        background-color: chartreuse;
        color: #000;
        font-weight: bold;
    }
    .border-bottom-blueGray{
        border-bottom: 1px solid lightgray !important;
    }
</style>
